function cuzTable(selector) {
	let table = {};

	const page_body = $('body');

	table.indexes = {
		id: 'id_property',
		name: 'name_user',
		last_name: 'last_name_user',
		request_at: 'dt_reg',
		city: 'city_name',
		neighborhood: 'neighborhood',
		request_status: 'state',
		approved_by: 'user_approved',
		updated_at: 'date_approved'
	};

	table.base_url = '';

	table.container = $(`${selector}`);
	table.selects = {};
	table.paginator = {};
	table.options = {};
	table.data = [];
	
	table.hideColumn = function (column) {
		
		if (column != '' && column != 'none') {
			
			table.options.columns_length--;
			const new_length_columns = table.options.columns_length;

			if (new_length_columns > 0) {

				const columns = $(`[data-column="${column}"]`);
				columns.hide();
				
				table.row.css('grid-template-columns', `repeat(${new_length_columns}, 1fr)`);
				table.selects.hide_column.siblings('.select').find(`[data-value="${column}"]`).hide();

			}

		} else if (column == 'none') {

			const columns = $('.request__table__row').children();
			columns.show();

			table.options.columns_length = $('.request__table__head.request__table__row').children().length;

			const new_length_columns = table.options.columns_length;

			table.row.css('grid-template-columns', `repeat(${new_length_columns}, 1fr)`);
			table.selects.hide_column.siblings('.select').find('.select__option').show();

		}

	}

	table.showFilter = function () {

		page_body.css({ 'overflow-y': 'hidden' });
		table.sifter.select.addClass('is--active');

	}

	table.hideFilter = function () {

		table.sifter.select.removeClass('is--active');
		page_body.css({ 'overflow-y': 'auto' });

	}

	table.setData = function (data) {
		table.data = data;
	}

	table.getUrlProperty = function (id) {
		return `${setBaseUrl(table.base_url)}/cms/properties/update/${id}`;
	}

	table.getStatusProperty = function (status) {
		if (status == 0) {
			return 'En proceso';
		}

		if (status == 1) {
			return 'Aprobado';
		}

		if (status == 2) {
			return 'Desaprobado';
		}

		if (status == null) {
			return '';
		}
	}

	table.notNull = function (value) {
		return (value == null) ? '' : value;
	}

	table.onLoader = function () {

		let html = `
			<div class="request__table__loader">
				<div class="spinner">
					<div class="bounce1"></div>
					<div class="bounce2"></div>
					<div class="bounce3"></div>
				</div>
			</div>
		`;

		table.container.html(html);

	}

	table.renderPaginate = function () {

		let index = table.paginator.data.index;
		let pages = table.paginator.data.pages;
		let view_container = table.paginator.elements.container;
		let view_index = table.paginator.elements.index;
		let view_left = table.paginator.elements.left;
		let view_right = table.paginator.elements.right;

		if (pages > 1) {
			view_container.addClass('is--active');
		} else {
			view_container.removeClass('is--active');
		}

		if (index == 1) {
			view_left.removeClass('is--active');
		} else {
			view_left.addClass('is--active');
		}

		if (index == pages) {
			view_right.removeClass('is--active');
		} else {
			view_right.addClass('is--active');
		}

		view_index.text(index);

	}

	table.paginatePrev = function () {

		if (table.paginator.data.index > 1) {
			table.paginator.data.index--;
			table.paginator.elements.left.trigger('change');
		}

		table.renderPaginate();

	}

	table.paginateNext = function () {

		if (table.paginator.data.index < table.paginator.data.pages) {
			table.paginator.data.index++;
			table.paginator.elements.right.trigger('change');
		}

		table.renderPaginate();

	}
	
	table.getPaginatePage = function () {

		return table.paginator.data.index;

	}

	table.paginate = function (pages) {

		if (pages == null) {
			console.error('cuzTable > ".paginate()" function receives a required parameter');
			pages = 0;
		} else {
			pages = parseInt(pages);
		}

		table.paginator.data.index = 1;
		table.paginator.data.pages = pages;

		table.renderPaginate();

	}

	table.renderTabs = function () {
		
		table.tabs = {};
		table.tabs.container = $('.request__tabs');
		table.tabs.buttons = table.tabs.container.find('.request__tabs__button');
	
		table.tabs.buttons.on('click', function () {
			table.tabs.buttons.removeClass('is--active');
			$(this).addClass('is--active').trigger('change');
		});

	}

	table.renderSifter = function () {

		table.sifter = {};
		table.sifter.container = $('.request__sifter');
		table.sifter.button = table.sifter.container.find('.button');
		table.sifter.select = $('.request__select');
		table.sifter.closer = table.sifter.select.find('[data-action="close"]');

		table.sifter.button.on('click', table.showFilter);
		table.sifter.closer.on('click', table.hideFilter);
		
	}

	table.renderOrders = function () {

		table.orders.find('.icon').removeClass('icon-chevron-down');
		table.orders.find('.icon').addClass('icon-two-sort');

		if ($(this).attr('data-order') == 'desc') {
			$(this).attr('data-order', 'asc');
		} else {
			$(this).attr('data-order', 'desc');
		}

		let icon = $(this).find('.icon');

		if ($(this).attr('data-order') == 'desc') {
			icon.removeClass('icon-two-sort');
			icon.removeClass('is--up');
			icon.addClass('icon-chevron-down');
		} else {
			icon.removeClass('icon-two-sort');
			icon.addClass('icon-chevron-down');
			icon.addClass('is--up');
		}

		$(this).trigger('change');

	}

	table.renderTbody = function (data) {

		let html = '';

		if (data.length > 0) {
			data.forEach(property => {
				html += `
					<a href="${table.getUrlProperty(property[table.indexes.id])}" class="request__table__body request__table__row">
						<div class="request__table__body__box" data-column="name">${table.notNull(property[table.indexes.name])} ${table.notNull(property[table.indexes.last_name])}</div>
						<div class="request__table__body__box" data-column="request-at">${table.notNull(property[table.indexes.request_at])}</div>
						<div class="request__table__body__box" data-column="city">${table.notNull(property[table.indexes.city])}</div>
						<div class="request__table__body__box" data-column="neighborhood">${table.notNull(property[table.indexes.neighborhood])}</div>
						<div class="request__table__body__box" data-column="request-status">${table.getStatusProperty(property[table.indexes.request_status])}</div>
						<div class="request__table__body__box" data-column="approved-by">${table.notNull(property[table.indexes.approved_by])}</div>
						<div class="request__table__body__box" data-column="updated-at">${table.notNull(property[table.indexes.updated_at])}</div>
					</a>
				`;
			});
		}
		
		if (data == false) {
			html = '<p class="request__table__noresults">Sin resultados...<p>';
		}

		return html;

	}

	table.renderTable = function () {
		let html = `
			<div class="request__table">
				<div class="request__table__head request__table__row">
					<div class="request__table__head__box" data-column="name"><div class="request__table__head__item is--filter for--name" data-order="desc">NOMBRE <span class="icon icon-two-sort"></span></div></div>
					<div class="request__table__head__box" data-column="request-at"><div class="request__table__head__item is--filter for--request-at" data-order="desc">FECHA DE SOLICITUD <span class="icon icon-two-sort"></span></div></div>
					<div class="request__table__head__box" data-column="city"><div class="request__table__head__item is--filter for--city" data-order="desc">CIUDAD <span class="icon icon-two-sort"></span></div></div>
					<div class="request__table__head__box" data-column="neighborhood"><div class="request__table__head__item is--filter for--neighborhood" data-order="desc">BARRIO / ZONA <span class="icon icon-two-sort"></span></div></div>
					<div class="request__table__head__box" data-column="request-status"><div class="request__table__head__item">ESTADO DE SOLICITUD</div></div>
					<div class="request__table__head__box" data-column="approved-by"><div class="request__table__head__item">APROBADO POR</div></div>
					<div class="request__table__head__box" data-column="updated-at"><div class="request__table__head__item is--filter for--updated-at" data-order="desc">FECHA DE MODIFICACIÓN <span class="icon icon-two-sort"></span></div></div>
				</div>
		`;

		html += '<div data-cuztable="data">'

		html += table.renderTbody(table.data);

		html += `
				</div >
			</div >`
		;

		html += `
			<div class="request__table__paginate">
				<div class="request__table__paginate__left"><span class="icon icon-triangle"></span></div>
				<div class="request__table__paginate__index">1</div>
				<div class="request__table__paginate__right"><span class="icon icon-triangle"></span></div>
			</div>
		`;

		html += `
			<div class="request__table__download">
				<button class="button button--white button--mx button--upper">Descargar base de datos</button>
			</div>
		`

		table.container.html(html);

		table.row = $('.request__table__row');
		table.options.columns_length = $('.request__table__head.request__table__row').children().length;

		table.orders = $('.request__table__head__item.is--filter');
		table.orders.on('click', table.renderOrders);

		table.paginator.elements = {};
		table.paginator.data = {};

		table.paginator.elements.container = $('.request__table__paginate');
		table.paginator.elements.left = $('.request__table__paginate__left');
		table.paginator.elements.right = $('.request__table__paginate__right');
		table.paginator.elements.index = $('.request__table__paginate__index');

		table.paginator.data.index = 0;
		table.paginator.data.pages = 0;

		table.paginator.elements.left.on('click', table.paginatePrev);
		table.paginator.elements.right.on('click', table.paginateNext);

		table.elements = {
			paginate_left: table.paginator.elements.left,
			paginate_right: table.paginator.elements.right,
			btn_download: $('.request__table__download .button'),
			order_name: $('.request__table__head__item.is--filter.for--name'),
			order_request_at: $('.request__table__head__item.is--filter.for--request-at'),
			order_city: $('.request__table__head__item.is--filter.for--city'),
			order_neighborhood: $('.request__table__head__item.is--filter.for--neighborhood'),
			order_updated_at: $('.request__table__head__item.is--filter.for--updated-at'),
		}
	}

	table.renderData = function () {

		table.container_data = $('[data-cuztable="data"]');

		let html = table.renderTbody(table.data);
		
		table.container_data.html(html);

		table.row = $('.request__table__row');
		table.options.columns_length = $('.request__table__head.request__table__row').children().length;

		table.row.css('grid-template-columns', `repeat(${table.options.columns_length}, 1fr)`);
		table.row.children().show();
		table.selects.hide_column.siblings('.select').find('.select__option').show();

	}
	
	table.init = function (base_url) {

		table.base_url = base_url;
		
		table.renderTabs();
		table.renderSifter();
		table.onLoader();
		
		table.selects.hide_column = $('[data-cuz-select="hide-column"]');
		table.selects.hide_column.on('change', function () {
			table.hideColumn($(this).val());

			const select = cuzSelect($(this));

			select.setValue('');
			select.renderSelect();
		});
	}


	return table;
}